module.exports = __webpack_public_path__ + "static/media/14.35647ff5.png";